$(document).ready(function() {
  // NAV LAYOUT 1 - Moving promotional items for first mega menu
  // Select the last li element in the first navigation container
  var lastPromoItem1 = $('#NavigationTier2-1 ul.navigation__tier-2').children('li').last();
  
  // Remove it from its current position
  lastPromoItem1.detach();
  
  // Insert it at the beginning of the first list
  $('#NavigationTier2-1 ul.navigation__tier-2').prepend(lastPromoItem1);
  
  // NAV LAYOUT 2 - Moving promotional items for second mega menu
  // Move the last promotion li to the first position in the second navigation
  var lastPromoItem2 = $('#NavigationTier2-2 ul.navigation__tier-2').children('li.navigation__column--promotion').last();
  
  // Remove it from its current position
  lastPromoItem2.detach();
  
  // Insert it at the beginning of the second list
  $('#NavigationTier2-2 ul.navigation__tier-2').prepend(lastPromoItem2);

  // NAV LAYOUT 3 - Moving promotional items for third mega menu
  // Move the last promotion li to the first position in the third navigation
  var lastPromoItem3 = $('#NavigationTier2-3 ul.navigation__tier-2').children('li.navigation__column--promotion').last();
  
  // Remove it from its current position if it exists
  if (lastPromoItem3.length) {
    lastPromoItem3.detach();
    
    // Insert it at the beginning of the third list
    $('#NavigationTier2-3 ul.navigation__tier-2').prepend(lastPromoItem3);
  }

  // NAV LAYOUT 4 - Moving promotional items for fourth mega menu
  // Move the last promotion li to the first position in the fourth navigation
  var lastPromoItem4 = $('#NavigationTier2-4 ul.navigation__tier-2').children('li.navigation__column--promotion').last();
  
  // Remove it from its current position if it exists
  if (lastPromoItem4.length) {
    lastPromoItem4.detach();
    
    // Insert it at the beginning of the fourth list
    $('#NavigationTier2-4 ul.navigation__tier-2').prepend(lastPromoItem4);
  }

  // NAV LAYOUT 5 - Moving promotional items for fifth mega menu
  // Move the last promotion li to the first position in the fifth navigation
  var lastPromoItem5 = $('#NavigationTier2-5 ul.navigation__tier-2').children('li.navigation__column--promotion').last();
  
  // Remove it from its current position if it exists
  if (lastPromoItem5.length) {
    lastPromoItem5.detach();
    
    // Insert it at the beginning of the fifth list
    $('#NavigationTier2-5 ul.navigation__tier-2').prepend(lastPromoItem5);
  }


  
  // FIRST NAV: FEATURED LINKS LI COLUMN
  // Get references to the relevant li elements (starting with Bundles, Shop by Age, Shop by Material)
  let bundlesLi = $('#NavigationTier2-1 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(2);
  let ageShopLi = $('#NavigationTier2-1 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(3);
  let materialShopLi = $('#NavigationTier2-1 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(4);
  
  // Check if all elements exist before proceeding
  if (bundlesLi.length && ageShopLi.length && materialShopLi.length) {
    // Use the first element (bundlesLi) as our base
    let combinedLi = bundlesLi;

    // Move content from the Age Shop li to the Bundles li
    let ageLink = ageShopLi.children('a.navigation__link').first().clone();
    let ageToggle = ageShopLi.children('a.navigation__children-toggle').first().clone();
    let ageContainer = ageShopLi.children('.navigation__tier-3-container').first().clone();
    
    combinedLi.append(ageLink);
    combinedLi.append(ageToggle);
    combinedLi.append(ageContainer);
    
    // Move content from the Material Shop li to the Bundles li
    let materialLink = materialShopLi.children('a.navigation__link').first().clone();
    let materialToggle = materialShopLi.children('a.navigation__children-toggle').first().clone();
    let materialContainer = materialShopLi.children('.navigation__tier-3-container').first().clone();
    
    combinedLi.append(materialLink);
    combinedLi.append(materialToggle);
    combinedLi.append(materialContainer);
    
    // Remove the now-redundant li elements
    ageShopLi.remove();
    materialShopLi.remove();
    
    // Move the combined LI (bundlesLi) to the last position
    combinedLi.detach();
    $('#NavigationTier2-1 ul.navigation__tier-2').append(combinedLi);
  }


  
  // SECOND NAV: COMBINE ELEMENTS
  // First create a combined element for the simple links (Glass, Steel, etc.)
  let glassLi = $('#NavigationTier2-2 ul.navigation__tier-2 > li').eq(1); // First non-promotional element
  let steelLi = $('#NavigationTier2-2 ul.navigation__tier-2 > li').eq(2);
  let mealPrepLi = $('#NavigationTier2-2 ul.navigation__tier-2 > li').eq(3);
  let pantryLi = $('#NavigationTier2-2 ul.navigation__tier-2 > li').eq(4);
  
  // Check if all elements exist before proceeding
  if (glassLi.length && steelLi.length && mealPrepLi.length && pantryLi.length) {
    // Use the first element (glassLi) as our base and preserve its original link/heading
    let combinedLi = glassLi;
    
    // Check if the base li (glassLi) already has a child tier-3 container
    if (combinedLi.find('.navigation__tier-3-container').length === 0) {
      // If it doesn't have a dropdown, we'll need to create one
      // First, get the original link text
      let originalLinkText = combinedLi.find('a.navigation__link').text();
      
      // Clear the li and create a dropdown structure
      combinedLi.empty();
      
      // Add the original link as a heading
      // combinedLi.append('<a href="#" class="navigation__link navigation__column-title heading-font h6-style" aria-haspopup="true" aria-expanded="false">' + originalLinkText + '</a>');
      combinedLi.append('<a class="navigation__children-toggle" href="https://bentgo.com/collections/glass-food-storage-containers"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><title>Toggle menu</title><polyline points="6 9 12 15 18 9"></polyline></svg></a>');
      
      // Create a container for the child links
      combinedLi.append('<div class="navigation__tier-3-container navigation__child-tier"><ul class="navigation__tier-3"></ul></div>');
      
      // Add the original link item to the dropdown
      combinedLi.find('ul.navigation__tier-3').append('<li class="navigation__item"><a class="navigation__link" href="https://bentgo.com/collections/glass-food-storage-containers">' + originalLinkText + '</a></li>');
      
      // Add the needed classes to the li
      combinedLi.addClass('navigation__item--with-children');
    }
    
    // Now that we have a proper dropdown structure, add the other links
    let combinedUl = combinedLi.find('ul.navigation__tier-3');
    
    // Move the content from each li into the combined dropdown
    // Steel element
    if (steelLi.hasClass('navigation__item--with-children')) {
      // It already has a dropdown, append its heading and move its items
      let steelHeading = steelLi.children('a.navigation__link').first().clone();
      let steelToggle = steelLi.children('a.navigation__children-toggle').first().clone();
      
      combinedLi.append(steelHeading);
      combinedLi.append(steelToggle);
      
      // Move all dropdown items
      steelLi.find('.navigation__tier-3 > li').each(function() {
        combinedUl.append($(this).clone());
      });
    } else {
      // It's a simple link
      let steelLink = steelLi.find('a.navigation__link').clone();
      combinedUl.append($('<li class="navigation__item"></li>').append(steelLink));
    }
    
    // Meal Prep element
    if (mealPrepLi.hasClass('navigation__item--with-children')) {
      // It already has a dropdown, append its heading and move its items
      let mealPrepHeading = mealPrepLi.children('a.navigation__link').first().clone();
      let mealPrepToggle = mealPrepLi.children('a.navigation__children-toggle').first().clone();
      
      combinedLi.append(mealPrepHeading);
      combinedLi.append(mealPrepToggle);
      
      // Move all dropdown items
      mealPrepLi.find('.navigation__tier-3 > li').each(function() {
        combinedUl.append($(this).clone());
      });
    } else {
      // It's a simple link
      let mealPrepLink = mealPrepLi.find('a.navigation__link').clone();
      combinedUl.append($('<li class="navigation__item"></li>').append(mealPrepLink));
    }
    
    // Pantry element
    if (pantryLi.hasClass('navigation__item--with-children')) {
      // It already has a dropdown, append its heading and move its items
      let pantryHeading = pantryLi.children('a.navigation__link').first().clone();
      let pantryToggle = pantryLi.children('a.navigation__children-toggle').first().clone();
      
      combinedLi.append(pantryHeading);
      combinedLi.append(pantryToggle);
      
      // Move all dropdown items
      pantryLi.find('.navigation__tier-3 > li').each(function() {
        combinedUl.append($(this).clone());
      });
    } else {
      // It's a simple link
      let pantryLink = pantryLi.find('a.navigation__link').clone();
      combinedUl.append($('<li class="navigation__item"></li>').append(pantryLink));
    }
    
    // Remove the now-redundant list items
    steelLi.remove();
    mealPrepLi.remove();
    pantryLi.remove();


    
    // Now combine the remaining navigation items with dropdowns (Bundles, Shop by Age, Shop by Material)
    // Get references after previous operations (skipping New Arrivals, Best Sellers, Personalization)
    let bundlesLi2 = $('#NavigationTier2-2 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(1);
    let ageShopLi2 = $('#NavigationTier2-2 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(2);
    let materialShopLi2 = $('#NavigationTier2-2 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(3);
    
    // Check if all elements exist before proceeding
    if (bundlesLi2.length && ageShopLi2.length && materialShopLi2.length) {
      // Use bundlesLi2 as the base
      let combinedNavLi = bundlesLi2;

      // Move content from the Age Shop li to the Bundles li
      let ageLink2 = ageShopLi2.children('a.navigation__link').first().clone();
      let ageToggle2 = ageShopLi2.children('a.navigation__children-toggle').first().clone();
      let ageContainer2 = ageShopLi2.children('.navigation__tier-3-container').first().clone();
      
      combinedNavLi.append(ageLink2);
      combinedNavLi.append(ageToggle2);
      combinedNavLi.append(ageContainer2);
      
      // Move content from the Material Shop li to the Bundles li
      let materialLink2 = materialShopLi2.children('a.navigation__link').first().clone();
      let materialToggle2 = materialShopLi2.children('a.navigation__children-toggle').first().clone();
      let materialContainer2 = materialShopLi2.children('.navigation__tier-3-container').first().clone();
      
      combinedNavLi.append(materialLink2);
      combinedNavLi.append(materialToggle2);
      combinedNavLi.append(materialContainer2);
      
      // Remove the now-redundant li elements
      ageShopLi2.remove();
      materialShopLi2.remove();
      
      // Move the combined bundles li to the last position
      combinedNavLi.detach();
      $('#NavigationTier2-2 ul.navigation__tier-2').append(combinedNavLi);
    }
  }


  

  // THIRD NAV: FEATURED LINKS LI COLUMN
  // Get references to the relevant li elements (starting with Bundles, Shop by Age, Shop by Material)
  let bundlesLi3 = $('#NavigationTier2-3 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(2);
  let ageShopLi3 = $('#NavigationTier2-3 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(3);
  let materialShopLi3 = $('#NavigationTier2-3 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(4);
  
  // Check if all elements exist before proceeding
  if (bundlesLi3.length && ageShopLi3.length && materialShopLi3.length) {
    // Use the first element (bundlesLi3) as our base
    let combinedLi3 = bundlesLi3;

    // Move content from the Age Shop li to the Bundles li
    let ageLink3 = ageShopLi3.children('a.navigation__link').first().clone();
    let ageToggle3 = ageShopLi3.children('a.navigation__children-toggle').first().clone();
    let ageContainer3 = ageShopLi3.children('.navigation__tier-3-container').first().clone();
    
    combinedLi3.append(ageLink3);
    combinedLi3.append(ageToggle3);
    combinedLi3.append(ageContainer3);
    
    // Move content from the Material Shop li to the Bundles li
    let materialLink3 = materialShopLi3.children('a.navigation__link').first().clone();
    let materialToggle3 = materialShopLi3.children('a.navigation__children-toggle').first().clone();
    let materialContainer3 = materialShopLi3.children('.navigation__tier-3-container').first().clone();
    
    combinedLi3.append(materialLink3);
    combinedLi3.append(materialToggle3);
    combinedLi3.append(materialContainer3);
    
    // Remove the now-redundant li elements
    ageShopLi3.remove();
    materialShopLi3.remove();
    
    // Move the combined LI to the last position
    combinedLi3.detach();
    $('#NavigationTier2-3 ul.navigation__tier-2').append(combinedLi3);
  }

  
  // FOURTH NAV: COMBINE ELEMENTS
  // Get references to the relevant li elements in the fourth navigation menu (starting with Bundles)
  // BNGO-24: an "Adults" subheader column was added after "Kids" in the Hydration menu, so
  // Bundles / Shop by Age / Shop by Material each shift one position (now eq 2/3/4).
  // This mirrors the THIRD NAV (Bags) layout, which already has Kids + Adults side by side.
  let bundlesLi4 = $('#NavigationTier2-4 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(2);
  let ageShopLi4 = $('#NavigationTier2-4 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(3);
  let materialShopLi4 = $('#NavigationTier2-4 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(4);
  
  // Check if all elements exist before proceeding
  if (bundlesLi4.length && ageShopLi4.length && materialShopLi4.length) {
    // Use the first element (bundlesLi4) as our base
    let combinedLi4 = bundlesLi4;

    // Move content from the Age Shop li to the Bundles li
    let ageLink4 = ageShopLi4.children('a.navigation__link').first().clone();
    let ageToggle4 = ageShopLi4.children('a.navigation__children-toggle').first().clone();
    let ageContainer4 = ageShopLi4.children('.navigation__tier-3-container').first().clone();
    
    combinedLi4.append(ageLink4);
    combinedLi4.append(ageToggle4);
    combinedLi4.append(ageContainer4);
    
    // Move content from the Material Shop li to the Bundles li
    let materialLink4 = materialShopLi4.children('a.navigation__link').first().clone();
    let materialToggle4 = materialShopLi4.children('a.navigation__children-toggle').first().clone();
    let materialContainer4 = materialShopLi4.children('.navigation__tier-3-container').first().clone();
    
    combinedLi4.append(materialLink4);
    combinedLi4.append(materialToggle4);
    combinedLi4.append(materialContainer4);
    
    // Remove the now-redundant li elements
    ageShopLi4.remove();
    materialShopLi4.remove();
    
    // Move the combined li to the last position
    combinedLi4.detach();
    $('#NavigationTier2-4 ul.navigation__tier-2').append(combinedLi4);
  }
  
  // FIFTH NAV: TWO OPERATIONS
  // 1. COMBINE Bundles, Shop by Age, Shop by Material and move to end
  // Get references to the relevant li elements in the fifth navigation menu
  let bundlesLi5 = $('#NavigationTier2-5 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(3);
  let ageShopLi5 = $('#NavigationTier2-5 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(4);
  let materialShopLi5 = $('#NavigationTier2-5 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(5);
  
  // Check if all elements exist before proceeding
  if (bundlesLi5.length && ageShopLi5.length && materialShopLi5.length) {
    // Use the first element (bundlesLi5) as our base
    let combinedLi5 = bundlesLi5;
    
    // Move content from the Age Shop li to the Bundles li
    let ageLink5 = ageShopLi5.children('a.navigation__link').first().clone();
    let ageToggle5 = ageShopLi5.children('a.navigation__children-toggle').first().clone();
    let ageContainer5 = ageShopLi5.children('.navigation__tier-3-container').first().clone();
    
    combinedLi5.append(ageLink5);
    combinedLi5.append(ageToggle5);
    combinedLi5.append(ageContainer5);
    
    // Move content from the Material Shop li to the Bundles li
    let materialLink5 = materialShopLi5.children('a.navigation__link').first().clone();
    let materialToggle5 = materialShopLi5.children('a.navigation__children-toggle').first().clone();
    let materialContainer5 = materialShopLi5.children('.navigation__tier-3-container').first().clone();
    
    combinedLi5.append(materialLink5);
    combinedLi5.append(materialToggle5);
    combinedLi5.append(materialContainer5);
    
    // Remove the now-redundant li elements
    ageShopLi5.remove();
    materialShopLi5.remove();
    
    // Move the combined li to the last position
    combinedLi5.detach();
    $('#NavigationTier2-5 ul.navigation__tier-2').append(combinedLi5);
  }


  
  // 2. COMBINE 1st, 2nd, 3rd ELEMENTS into an li in the 2nd position
  // Note: After removing promotional items, we need to get fresh references
  // Get references to the relevant li elements in the fifth navigation menu (adjusting for previous changes)
  let fifthNavFirstLi = $('#NavigationTier2-5 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(0); // 1st element (after promo)
  let fifthNavSecondLi2 = $('#NavigationTier2-5 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(1); // 2nd element
  let fifthNavThirdLi2 = $('#NavigationTier2-5 ul.navigation__tier-2 > li.navigation__item.navigation__column').eq(2); // 3rd element
  
  // Check if all elements exist before proceeding
  if (fifthNavFirstLi.length && fifthNavSecondLi2.length && fifthNavThirdLi2.length) {
    // We'll use the first element as our base and append content from others to it
    let combinedLi5_2 = fifthNavFirstLi;
    
    // Add content from the second li to the first li
    // First, get the heading link and toggle button
    let secondHeading = fifthNavSecondLi2.children('a.navigation__link').first().clone();
    let secondToggle = fifthNavSecondLi2.children('a.navigation__children-toggle').first().clone();
    let secondContainer = fifthNavSecondLi2.children('.navigation__tier-3-container').first().clone();
    
    combinedLi5_2.append(secondHeading);
    combinedLi5_2.append(secondToggle);
    combinedLi5_2.append(secondContainer);
    
    // Add content from the third li to the first li
    let thirdHeading = fifthNavThirdLi2.children('a.navigation__link').first().clone();
    let thirdToggle = fifthNavThirdLi2.children('a.navigation__children-toggle').first().clone();
    let thirdContainer = fifthNavThirdLi2.children('.navigation__tier-3-container').first().clone();
    
    combinedLi5_2.append(thirdHeading);
    combinedLi5_2.append(thirdToggle);
    combinedLi5_2.append(thirdContainer);
    
    // Remove the now-redundant list items
    fifthNavSecondLi2.remove();
    fifthNavThirdLi2.remove();
    
    // Move the combined li to the second position
    combinedLi5_2.detach();
    lastPromoItem5.after(combinedLi5_2);
  }
});